import { ViolationService } from '../../../violations-sets/violation-service/violation.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import * as _ from 'underscore';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { ServiceAreasService } from '../../../service-areas/service-areas-service/service-areas.service';
import { checkRole, PlanType, weekDays } from 'src/app/utils/utils.common';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { StaffService } from 'src/app/component/staffs/staff-service/staff.service';
import { PlannerLoadWrapperComponent } from '../planner-load-wrapper/planner-load-wrapper.component';
import { PlannerNearbyWiseService } from 'src/app/service/planning-services/planning-nearbywise-service';
import { PlanningAreasWiseService } from 'src/app/service/planning-services/planning-areaswise-service';
import { PlannerTemplateWiseService } from 'src/app/service/planning-services/planning-templatewise-service';
import { PlannerSameLegsService } from 'src/app/service/planning-services/planning-samelegs-service';
import { PlannerJspritService } from 'src/app/service/planning-services/planning-jsprit-service';
import { environment } from 'src/environments/environment';
import { PlannerGroupService } from 'src/app/service/planning-services/planning-groupwise-service';
@Component({
  selector: 'app-planner-schedule-modal',
  templateUrl: './planner-schedule-modal.component.html',
  styleUrls: ['./planner-schedule-modal.component.css']
})
export class PlannerScheduleModalComponent implements OnInit {
  @ViewChild('plannerWrapper', { static: false }) plannerWrapper: PlannerLoadWrapperComponent;
  plannerWrapperModalObj = false;
  PlanType = PlanType;
  selectedPlanType: PlanType = PlanType.NEARBY_WISE;
  user: any;
  search = '';
  scheduleTripLogsObj = null;
  timeZone;

  mappers = [];
  templates = [];

  drivers = [];
  serviceAreasWiseDrivers = [];
  filtersserviceAreasWiseDriver = [];
  selectedDrivers = [];

  preServiceAreas = {};
  serviceAreaList = [];
  selectedServiceAreas = [];

  preViolations = {};

  submitted = false;
  violation = 'batch';
  timeCalibration = "none";
  allowManifestTrips = false;
  selectedMapper = null;
  selectedTemplate = null;
  @Input() preData;
  @Output() closeModal = new EventEmitter();
  planedTrips: any;
  driverTrips = [];
  selectedDriver;
  selectedDriverId = '';
  preFleet = {};

  plannedDrivers = 0;
  publishedDrivers = 0;
  days = weekDays;

  preStaffList = {};
  stationManagerList = [];
  selectedStationManager = [];
  filteredDrivers = [];
  isAllowRates = false;
  staff;
  selectedTab = 'planner';
  templateModalObj;
  isMakeLiveForAll = false;
  isHideControlls = false;
  overlappingTripIds: string[] = []; // Add this variable
  overlappingTripSet: Set<string> = new Set<string>();
  selectedMethod: any = false;
  proceedLoader = {
    isLoading: false
  }
  selectedTable = 'driverWise';
  driverStops: any[] = [];
  driverViewMode: string = 'stops';
  bucketObj;
  groupWiseObj;
  selectedMapperFilter = '';
  manifestTrips = [];
  preDrivers;
  shiftMappers = {};
  isshowAllDrivers = false;
  routePlanner = false;
  isProduction = environment.production;
  preDriversShiftOverrides;

  constructor(
    private driverService: DriversService,
    private violationService: ViolationService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,
    private fleetService: FleetService,
    private staffService: StaffService,
    private planningAreasWiseService: PlanningAreasWiseService,
    private plannerNearbyWiseService: PlannerNearbyWiseService,
    private plannerGroupService: PlannerGroupService,
    private plannerJspritService: PlannerJspritService,
    private plannerTemplateWiseService: PlannerTemplateWiseService,
    private plannerSameLegsService: PlannerSameLegsService

  ) { }

  ngOnInit() {
    this.getUser();
    // console.log('preData:', this.preData);
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;
          this.getServiceAreaList();
          this.getDriverList();
          this.getViolationData();
          this.getMappers();
          this.getShiftMappers();
          this.getTemplates();
          this.getFleetList();
          this.getStaffList();
          this.getManifestTrips();
          this.getDriversShiftOverrides();
          this.isAllowRates = checkRole(this.user);


        }
      });
  }

  getDriverList() {
    this.driverService
      .getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.drivers = data;
          this.preDrivers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getStaffList() {
    this.staffService
      .getStaffList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.staff = data;
          this.stationManagerList = data.filter(staff => ["mdispatcher", "mcallcenter", "rdispatcher"].includes(staff.roles));;
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  getServiceAreaList() {
    this.serviceArea
      .getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.serviceAreaList = data;
          this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preFleet = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getViolationData() {
    this.violationService.getViolationData()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.preViolations = data;
          console.log("Violations", data);
        }
      });
  }

  getMappers() {
    this.assignTripService
      .getPlannerTemplates()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.mappers = data;
        }
      });
  }

  getShiftMappers() {
    this.assignTripService
      .getDriverPlannerTemplates()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.shiftMappers = data.reduce((obj, item) => (obj[item.driver] = item, obj), {});;
        }
      });
  }

  getTemplates() {
    this.assignTripService
      .getTemplates('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.templates = data;
        }
      });
  }

  closeScheduleModal(value) {
    this.closeModal.emit(value)
  }

  onDateChange(evt, control: AbstractControl) {
    if (evt) {
      control.setValue(moment(evt).toISOString());
    }
  }


  onSelectServiceArea(service) {
    service.isSelected = !service.isSelected;
    if (service.isSelected) {
      this.selectedServiceAreas.push(service._id);
    } else {
      const idx = this.selectedServiceAreas.indexOf(service._id);
      this.selectedServiceAreas.splice(idx, 1);
    }
    this.filterDriverServiceAreasWise();
    this.autoSelectTemplateDrivers();
  }

  filterDriverServiceAreasWise() {
    this.serviceAreasWiseDrivers = [];
    this.filteredDrivers = [];
    this.selectedDrivers = [];
    this.drivers.forEach(driver => {
      const isFound = driver.serviceAreas.some(serviceId => this.selectedServiceAreas.includes(serviceId));
      if (isFound) {
        if (!this.serviceAreasWiseDrivers.find(d => d._id === driver._id)) {
          this.serviceAreasWiseDrivers.push({ ...driver, isSelected: false });
        }
      }
    });

    this.stationManagerWiseDrivers();
  }

  stationManagerWiseDrivers() {
    this.filteredDrivers = [];
    if (this.selectedStationManager && this.selectedStationManager.length) {
      for (let driver of this.serviceAreasWiseDrivers) {
        if (driver.stationManager && this.selectedStationManager.includes(driver.stationManager)) {
          this.filteredDrivers.push(driver);
        }
      }
    }
    else if (this.serviceAreasWiseDrivers.length) {
      for (let driver of this.serviceAreasWiseDrivers) {
        this.filteredDrivers.push(driver);
      }
    }
  }

  mapperWiseDrivers() {

    const selectedMapperObj = this.mappers.find(mapper => mapper._id === this.selectedMapperFilter);

    if (!selectedMapperObj || !selectedMapperObj.mappers) {
      this.filteredDrivers = [...this.serviceAreasWiseDrivers];
      return;
    }

    const driverIdsInMapper = Object.keys(selectedMapperObj.mappers);

    this.filteredDrivers = this.serviceAreasWiseDrivers.filter(driver =>
      driverIdsInMapper.includes(driver._id)
    );
  }

  onSelectDriver(driver) {
    driver.isSelected = !driver.isSelected;
    if (driver.isSelected) {
      this.selectedDrivers.push(driver);
    } else {
      const idx = this.selectedDrivers.findIndex(d => d._id === driver._id);
      this.selectedDrivers.splice(idx, 1);
    }
  }

  selectAllServiceArea(isTrue) {
    this.selectedServiceAreas = [];
    this.serviceAreaList.forEach(serviceArea => {
      if (isTrue) {
        serviceArea.isSelected = true;
        this.selectedServiceAreas.push(serviceArea._id);
      } else {
        serviceArea.isSelected = false;
      }
    });

    this.filterDriverServiceAreasWise();
    this.autoSelectTemplateDrivers();
  }

  selectAllDrivers(isTrue) {
    this.selectedDrivers = [];
    this.filteredDrivers.forEach(driver => {
      if (isTrue) {
        driver.isSelected = true;
        this.selectedDrivers.push(driver);
      } else {
        driver.isSelected = false;
      }
    });
  }

  onSelectViolation(violation) {
    this.violation = violation
  }

  onSelectTimeCalibration(timeCalibration) {
    this.timeCalibration = timeCalibration
  }

  onSelectMapper(mapper) {
    if (mapper) {
      this.selectedMapper = this.mappers.find(item => item._id === mapper);
    } else {
      this.selectedMapper = null;
    }
  }

  async onProceed() {
    if (this.selectedPlanType === PlanType.TEMPLATE_WISE) {
      if (!this.selectedTemplate || !this.selectedDrivers || !this.selectedDrivers.length) {
        return;
      }
    } else {
      if (!this.selectedDrivers || !this.selectedDrivers.length || !this.violation || !this.selectedMapper) {
        return;
      }
    }

    this.proceedLoader.isLoading = true;

    if (this.selectedMethod === 'osrm') {
      await this.prefetchOsrmForPlanner();
    }

    if (this.selectedPlanType === PlanType.TEMPLATE_WISE) {
      this.planedTrips = await this.plannerTemplateWiseService.planTrips(this.user, this.preData, this.selectedDrivers, this.selectedTemplate, this.selectedMethod, this.timeCalibration);
    } else {
      if (this.selectedPlanType === PlanType.J_SPRIT) {
        this.planedTrips = await this.plannerJspritService.planTrips(this.user, this.preData, this.preFleet, this.preViolations[this.violation], this.selectedMapper, this.selectedDrivers, this.selectedMethod, this.timeCalibration, this.allowManifestTrips ? this.manifestTrips : [], this.preDrivers, this.shiftMappers);
        console.log("Jsprit plan", this.planedTrips);
      } else if (this.selectedPlanType === PlanType.NEARBY_WISE) {
        this.planedTrips = await this.plannerNearbyWiseService.planTrips(this.user, this.preData, this.preFleet, this.preViolations[this.violation], this.selectedMapper, this.selectedDrivers, this.selectedMethod, this.timeCalibration, this.allowManifestTrips ? this.manifestTrips : [], this.preDrivers, this.shiftMappers);
      } else if (this.selectedPlanType === PlanType.GROUP_WISE) {
        this.planedTrips = await this.plannerGroupService.planTrips(this.user, this.preData, this.preFleet, this.preViolations[this.violation], this.selectedMapper, this.selectedDrivers, this.selectedMethod, this.timeCalibration, this.allowManifestTrips ? this.manifestTrips : [], this.preDrivers, this.shiftMappers);
      } else if (this.selectedPlanType === PlanType.LEG_WISE) {
        this.planedTrips = await this.plannerSameLegsService.planTrips(this.user, this.preData, this.preFleet, this.preViolations[this.violation], this.selectedMapper, this.selectedDrivers, this.selectedMethod, this.timeCalibration, this.shiftMappers, this.allowManifestTrips ? this.manifestTrips : [], this.preDrivers);
      } else {
        this.planedTrips = await this.planningAreasWiseService.planTrips(this.user, this.preData, this.preFleet, this.preViolations[this.violation], this.selectedMapper, this.selectedDrivers, this.selectedMethod, this.timeCalibration, this.shiftMappers);
      }
    }

    this.plannedDrivers = this.getPlannedDriversCount();
    this.overLapChangeDetection();
    if (this.planedTrips && this.planedTrips.compatible) {
      const compatibleKeys = Object.keys(this.planedTrips.compatible);
      if (compatibleKeys.length > 0 && !this.selectedDriverId) {
        this.selectedDriverTrips(compatibleKeys[0]);
      }
    }
  }

  selectedDriverTrips(key) {
    if (key) {
      if (this.planedTrips && this.planedTrips.compatible && this.planedTrips.compatible[key] && this.planedTrips.compatible[key].trips) {
        this.driverTrips = this.planedTrips.compatible[key].trips;
        this.driverStops = this.planedTrips.compatible[key].stops || [];
        this.selectedDriver = this.planedTrips.compatible[key].driver;
        this.selectedDriverId = this.selectedDriver ? this.selectedDriver._id : '';
        this.overLapChangeDetection();
      } else {
        this.driverTrips = [];
        this.driverStops = [];
      }

      // console.log("Driver trip check",this.driverTrips);
    } else {
      this.driverTrips = [];
      this.driverStops = [];
      this.selectedDriver = null;
      this.selectedDriverId = '';
    }

  }

  removeTrip(assign) {

    let findTripIndex = this.driverTrips.findIndex(t => t._id === assign._id);
    this.driverTrips.splice(findTripIndex, 1);
    this.planedTrips.nonCompatible.push(assign);
  }

  removeTripFromAll(listing, assign) {
    // remove from single as well
    let findTripIndex = this.driverTrips.findIndex(t => t._id === assign._id);
    this.driverTrips.splice(findTripIndex, 1);
    // remove from all listing

    let findAllTripIndex = listing.findIndex(t => t._id === assign._id);
    listing.splice(findAllTripIndex, 1);

    this.planedTrips.nonCompatible.push(assign);
  }



  assignTrip(assign, key) {
    // this.driverTrips.push(assign);
    this.planedTrips.compatible[key].trips.push(assign);
    let findTripIndex = this.planedTrips.nonCompatible.findIndex(t => t._id === assign._id);
    this.planedTrips.nonCompatible.splice(findTripIndex, 1);

    this.driverTrips.sort((a, b) =>
      moment(a.scheduleTime).tz(this.timeZone).diff(moment(b.scheduleTime).tz(this.timeZone))
    );

    this.overLapChangeDetection();

  }

  liveTrip() {

    sweetAlert(
      "Alert",
      `Proceed with making '${this.selectedDriver.displayName}' plan live?`,
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        const finalPayload = [];
        if (!this.driverTrips || !this.driverTrips.length) {
          sweetAlert('Error', 'No trips to assign', 'warning', 'OK');
          return;
        }
        for (const trip of this.driverTrips) {

          if (trip.preTrip) {
            continue;
          }

          const payload = {
            selectedTrips: [trip._id],
            status: 'offered',
            priority: trip.priority,
            assignThrough: 'planner',
            driver: {
              _id: this.selectedDriver._id,
              displayName: this.selectedDriver.displayName,
              profileImageURL: this.selectedDriver.profileImageURL,
            },
          };
          finalPayload.push(payload);
        }

        this.assignTripService.liveTripsForMultipleDriver({ data: finalPayload }).subscribe((data) => {
          if (data) {
            this.isHideControlls = true;
            this.selectedDriver.tripStatus = 'published'
            this.plannedDrivers -= 1;
            this.publishedDrivers += 1;
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        })
      }

    })
  }

  onDriverLoadTripsLive() {
    this.closeScheduleModal(false);
  }

  onDriverLoadMakeItLive(driverId) {
    this.selectedDriverTrips(driverId);
    this.liveTrip();
  }

  getPlannedDriversCount() {
    let count = 0;
    // debugger;
    if (this.planedTrips && this.planedTrips.compatible) {
      count = Object.keys(this.planedTrips.compatible).filter(drId => this.planedTrips.compatible[drId].driver.tripStatus == undefined).length
    }
    return count;
  }

  logs() {
    this.scheduleTripLogsObj = this.planedTrips.tripLogs;
  }

  sortMethod(a, b) {
    return a.value.driver.displayName - b.value.driver.displayName
  }

  currentDayShift(shifts) {
    const currentDay = moment(this.preData.date).day();
    if (shifts) {
      let shift = shifts.find(shift => shift.day === currentDay);
      return shift;
    } else {
      return {};
    }
  }

  setTab(tab) {
    this.selectedTab = tab;
    if (this.selectedTab === 'driverload') {
      this.plannerWrapperModalObj = true;
      this.bucketObj = false;
      this.groupWiseObj = false;
      this.routePlanner = false;
    } else if (this.selectedTab === 'planner') {
      this.plannerWrapperModalObj = false;
      this.bucketObj = false;
      this.groupWiseObj = false;
      this.routePlanner = false;
    } else if (this.selectedTab === 'buckets') {
      this.bucketObj = true
      this.plannerWrapperModalObj = false;
      this.groupWiseObj = false;
      this.routePlanner = false;
    } else if (this.selectedTab === 'jsprit' || this.selectedTab === PlanType.GROUP_WISE || this.selectedTab === PlanType.NEARBY_WISE || this.selectedTab === PlanType.LEG_WISE) {
      this.routePlanner = false;
      this.bucketObj = false
      this.plannerWrapperModalObj = false;
      this.groupWiseObj = true;
    }
    // this.plannerWrapperModalObj = tab === 'driverload' ? true : false;
    this.selectedDriverTrips(this.selectedDriverId)
  }

  setTable(tab) {
    this.selectedTable = tab;
    this.selectedDriverTrips('');
  }


  closeTemplateModal() {
    this.templateModalObj = undefined;
  }

  openTemplateModal() {
    // this.templateModalObj = {
    //   drivers: this.selectedDrivers,
    //   planedTrips: this.planedTrips
    // };

    const bucket = this.planedTrips.compatible;
    const template = []
    Object.keys(bucket).forEach(b => {
      const driver = bucket[b].driver;
      const trips = bucket[b].trips;
      let members = trips.map(trip => {
        return {
          ...trip.priorityClient,
          _id: trip.client
        }
      });
      members = _.uniq(members, '_id').sort();
      template.push({
        driver: driver,
        members: members
      });
    });
    this.templateModalObj = template;
  }

  // onChangeTemplate(evt) {
  // }

  onSelectTemplate(templateId) {
    this.selectAllServiceArea(true);
    this.selectedTemplate = {};
    if (templateId) {
      const template = this.templates.find(template => template._id === templateId);
      this.selectedTemplate = template && template.mappers && template.mappers.length ? template.mappers : null;
    } else {
      this.selectedTemplate = null;
    }

    this.autoSelectTemplateDrivers();
  }

  autoSelectTemplateDrivers() {
    this.filteredDrivers.forEach(driver => driver.isSelected = false);
    if (this.selectedTemplate && this.selectedTemplate.length && this.filteredDrivers && this.filteredDrivers.length) {
      this.selectedDrivers = [];
      this.selectedTemplate.forEach(t => {
        const driver = this.filteredDrivers.find(driver => driver._id === t.driver);
        if (driver) {
          driver.isSelected = true;
          this.selectedDrivers.push(driver);
        }
      });
    }
  }


  liveTripsForAll() {

    const finalPayload = [];

    for (const key in this.planedTrips.compatible) {
      if (!(this.planedTrips.compatible[key].trips && this.planedTrips.compatible[key].trips.length)) {
        delete this.planedTrips.compatible[key]
      }
      if (this.planedTrips.compatible[key]) {
        const driver = this.planedTrips.compatible[key].driver;


        if (driver.tripStatus === 'published') {
          continue;
        }

        for (const trip of this.planedTrips.compatible[key].trips) {

          if (trip.preTrip) {
            continue;
          }

          const payload = {
            selectedTrips: [trip._id],
            status: 'offered',
            priority: trip.priority,
            assignThrough: 'planner',
            driver: {
              _id: driver._id,
              displayName: driver.displayName,
              profileImageURL: driver.profileImageURL,
            },
          };
          finalPayload.push(payload);
        }
      }
    }
    sweetAlert(
      "Alert",
      "Proceed with making all drivers' plan live?",
      "warning",
      "Yes",
      "No"
    ).then((result: any) => {
      if (result.value) {
        this.assignTripService.liveTripsForMultipleDriver({ data: finalPayload }).subscribe((data) => {
          if (data) {
            this.isMakeLiveForAll = true;
            for (const key in this.planedTrips.compatible) {
              this.planedTrips.compatible[key].driver.tripStatus = 'published';
            }
            this.plannedDrivers = 0;
            this.publishedDrivers = Object.keys(this.planedTrips.compatible).length;
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        })
      }
    });

  }

  lateIndication(): string[] {
    if (this.violation === 'force' || !this.driverTrips || this.driverTrips.length < 2) {
      return [];
    }
    const selectedViolation = this.preViolations[this.violation];
    if (!selectedViolation || selectedViolation.overlapIndication == null) {
      return [];
    }
    const bufferMs = (Number(selectedViolation.overlapIndication) || 0) * 60000;
    const overlappingTripIds: string[] = [];
    for (let i = 0; i < this.driverTrips.length - 1; i++) {
      const currentTrip = this.driverTrips[i];
      const nextTrip = this.driverTrips[i + 1];

      const curSched = currentTrip.scheduleTime ? new Date(currentTrip.scheduleTime).getTime() : 0;
      const curAppt = currentTrip.appointmentTime ? new Date(currentTrip.appointmentTime).getTime() : 0;
      const nextSched = nextTrip.scheduleTime ? new Date(nextTrip.scheduleTime).getTime() : 0;
      const nextAppt = nextTrip.appointmentTime ? new Date(nextTrip.appointmentTime).getTime() : 0;

      const currentPickupEnd = curSched - bufferMs;
      const currentAppointmentEnd = curAppt + bufferMs;

      const isPickupOverlap = currentPickupEnd > nextSched;
      const isPickupAppointmentOverlap = currentPickupEnd > nextAppt;
      const isAppointmentPickupOverlap = currentAppointmentEnd > nextSched;
      const isAppointmentOverlap = currentAppointmentEnd > nextAppt;

      if (isPickupOverlap || isPickupAppointmentOverlap || isAppointmentPickupOverlap || isAppointmentOverlap) {
        overlappingTripIds.push(currentTrip._id, nextTrip._id);
      }
    }
    return overlappingTripIds;
  }

  overLapChangeDetection() {
    const ids = this.lateIndication() || [];
    this.overlappingTripIds = ids;
    this.overlappingTripSet = new Set(ids);
  }

  isTripOverlapping(tripId: string): boolean {
    return this.overlappingTripSet.has(tripId);
  }

  trackByTripId(_index: number, trip: any): string {
    return trip ? (trip._id || trip.id || _index) : _index;
  }

  trackByDriverKey(_index: number, item: any): string {
    return item ? (item.key || item._id || _index) : _index;
  }

  async prefetchOsrmForPlanner() {
    if (this.selectedMethod !== 'osrm') return;
    try {
      const activeDrivers = (this.selectedDrivers && this.selectedDrivers.length) ? this.selectedDrivers : [];
      const points = this.assignTripService.collectPlannerCoordinates(
        this.preData,
        activeDrivers,
        null,
        this.allowManifestTrips ? this.manifestTrips : []
      );
      if (points && points.length > 1) {
        await this.assignTripService.prefetchOsrmTableMatrix(points);
      }
    } catch (err) {
      console.warn('OSRM prefetch failed in planner:', err);
    }
  }

  onChangeMilesSelector(event) {
    if (event === 'true' || event === true) {
      this.selectedMethod = true;
    } else if (event === 'false' || event === false) {
      this.selectedMethod = false;
    } else {
      this.selectedMethod = event;
      if (event === 'osrm' && this.selectedDrivers && this.selectedDrivers.length) {
        this.prefetchOsrmForPlanner();
      }
    }
  }


  getManifestTrips() {
    let jobStatuses = ['offered', 'accepted', 'onway', 'arrived', 'started'];
    const object = {
      status: 'manifest',
      date: this.preData.date,
      jobStatuses,
    };
    this.assignTripService.getAssignManifestList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.manifestTrips = data;

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  showAllDrivers() {
    this.isshowAllDrivers = !this.isshowAllDrivers;
    if (!this.planedTrips || !this.planedTrips.compatible) return;

    if (this.isshowAllDrivers) {
      const currentDriverIds = Object.keys(this.planedTrips.compatible);
      const selectedDriverIds = this.filteredDrivers.map(d => d._id);

      selectedDriverIds.forEach(driverId => {
        if (!currentDriverIds.includes(driverId)) {
          const driver = this.preDrivers[driverId];
          if (driver) {
            this.planedTrips.compatible[driverId] = {
              driver: driver,
              trips: []
            };
          }
        }
      });

    } else {
      for (const key in this.planedTrips.compatible) {
        if (!(this.planedTrips.compatible[key].trips && this.planedTrips.compatible[key].trips.length)) {
          delete this.planedTrips.compatible[key];
        }
      }
    }

  }

  getDriversShiftOverrides() {
    const payload = {
      startDate: moment.tz(this.preData.date, this.timeZone).startOf('day').toISOString(),
      endDate: moment.tz(this.preData.date, this.timeZone).endOf('day').toISOString(),
      status: 'active'
    }
    this.driverService
      .getShiftOverridesByDate(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          const shiftOverrides = data;
          if (shiftOverrides && shiftOverrides.length) {
            this.preDriversShiftOverrides = shiftOverrides.reduce((acc, override) => {
              const { driver, shift } = override;
              const { _id } = driver;
              if (shift) {
                if (!acc[_id]) {
                  acc[_id] = [];
                }
                acc[_id].push(override);
              }

              return acc;
            }, {});
          }
        }
      });
  }


  ngOnDestroy(): void {

  }


}
